<script setup lang="ts">
import IconTabBarVideoChat from '@/shared/assets/icons/IconTabBarVideoChat.svg'

import CabHeaderNavWrap from './CabHeaderNavWrap.vue'

defineProps({
  to: {
    type: String,
    required: true,
  },
  inCall: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <CabHeaderNavWrap :to="to" :in-call="inCall" data-test="widget_header__button_video-chat">
    <IconTabBarVideoChat class="h-24 w-24 fill-gray-500 lg:mr-6 lg:group-hover:fill-black" />
    <span class="hidden lg:inline">{{ $t('header.video_chat') }}</span>
  </CabHeaderNavWrap>
</template>
